import { createSlice } from '@reduxjs/toolkit';

export const userProfile = createSlice({
    name: 'userProfile',

    initialState: {
        userProfile: {
            consumerId: 0,
            userId: '',
            leadIdGuid: '',
            firstName: '',
            lastName: '',
            zip: '',
            county: '',
            email: '',
            phoneNumber: '',
            dateOfBirth: '',
            inactive: 0,
            hasMedicAid: null
        }
    },

    reducers: {
        setUserProfile: (state, action) => {
            state.userProfile = action.payload || {};
        }
    }
});

export const { setUserProfile } = userProfile.actions;

export default userProfile.reducer;
